import { ReactNode } from "react";
import { tv } from "tailwind-variants";
import { cn } from "../../../utils/class-names";

interface NavLinkContainerProps {
  className?: string;
  children?: ReactNode;
}

export function NavLinkContainer({
  className,
  children,
}: NavLinkContainerProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-7", className)}>{children}</div>
  );
}

export const navLink = tv({
  base: "flex items-center gap-2.5 text-base font-medium text-shale-300",
  variants: {
    isActive: {
      true: "text-white",
    },
  },
});
